import angular from 'angular';
import modalWarningDelegationComponent from './modalWarningDelegation.component';

let modalWarningDelegationModule = angular.module('modalWarningDelegation', [])

.component('modalWarningDelegation', modalWarningDelegationComponent)

.name;

export default modalWarningDelegationModule;



// WEBPACK FOOTER //
// ./client/app/components/modalWarningDelegation/modalWarningDelegation.js